module.exports = "button{margin-right:5px}"